@if (label() || labelTemplate()) {
  <div class="hx-table-section__label" [style.color]="labelColor()">
    @if (labelTemplate()) {
      <div class="label-with-index">
        <span class="hx-table-section__index">{{ sectionIndex() + 1 }}.</span>
        <ng-container
          *ngTemplateOutlet="labelTemplate(); context: { $implicit: label(), index: sectionIndex() }"></ng-container>
      </div>
    } @else {
      <hx-label class="hx-table-section__hx-label" [description]="sectionIndex() + 1 + '. ' + label()"></hx-label>
    }
  </div>
}
<div class="hx-table-section__rows">
  <ng-content select="hx-table-row"></ng-content>
</div>
